import { PINNED_POSTS_KEY, FEED_KEY, POSTS_KEY } from '../../utils/keys';
// get all active/inactive posts queries
export const postsQueryFilter = {
    predicate: query => {
        var _a;
        const { state, queryKey } = query;
        const [main] = queryKey || [];
        if ((main === FEED_KEY || main === POSTS_KEY) &&
            Array.isArray((_a = state === null || state === void 0 ? void 0 : state.data) === null || _a === void 0 ? void 0 : _a.pages) // checking if the disabled(inactive) query actually has data to update or not
        ) {
            return true;
        }
        return false;
    },
};
export const pinnedPostsFilter = {
    predicate: query => {
        var _a;
        const queryMainKey = (_a = query === null || query === void 0 ? void 0 : query.queryKey) === null || _a === void 0 ? void 0 : _a[0];
        if (queryMainKey === PINNED_POSTS_KEY) {
            return true;
        }
        return false;
    },
};
// to get one replies/posts query with a specific id
export const getPostsQueryById = postId => ({
    predicate: query => {
        var _a, _b;
        const { state, queryKey } = query;
        const [main, args] = queryKey || [];
        if (main === POSTS_KEY &&
            ((_a = args) === null || _a === void 0 ? void 0 : _a.postId) === postId &&
            Array.isArray((_b = state === null || state === void 0 ? void 0 : state.data) === null || _b === void 0 ? void 0 : _b.pages) // checking if the disabled(inactive) query actually has data to update or not
        ) {
            return true;
        }
        return false;
    },
});
//# sourceMappingURL=filters.js.map